import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMyOrders } from "./types";
import { RequestStatus } from "@app/constants";

const initialState: IMyOrders = {
  myOrders: {},
};

const slice = createSlice({
  name: "myOrders",
  initialState,
  reducers: {
    getMyOrders(state, action: PayloadAction<any>) {
      state.myOrders.status = RequestStatus.RUNNING;
    },
    getMyOrdersSuccess(state, action) {
      state.myOrders.status = RequestStatus.SUCCESS;
      state.myOrders.data = action.payload;
    },
    getMyOrdersFailed(state, action: PayloadAction<any>) {
      state.myOrders.status = RequestStatus.ERROR;
      state.myOrders.error = action.payload;
    },
    clearOrder(state){
      state.myOrders = initialState;      
    }
  },
});

export default slice.reducer;
export const { getMyOrders, getMyOrdersSuccess, getMyOrdersFailed , clearOrder} =
  slice.actions;
